const API_URL = process.env.REACT_APP_CONVERT_XML_API_URL || '';
const API_KEY = process.env.REACT_APP_API_KEY || '';

export interface DeleteInstallmentRequest {
  action: 'delete_installment';
  operation_code: string;
  document_id: string;
  installment_number: string;
}

export interface DeleteDocumentRequest {
  action: 'delete_document';
  operation_code: string;
  document_id: string;
}

export interface DeleteResponse {
  status: string;
  action: string;
  operation_code: string;
  document_id: string;
  deleted_installment?: string;
  deleted_amount: number;
  reorganized_installments?: number;
  deleted_receivables?: number;
  operation_deleted?: boolean;
  s3_updated?: boolean;
  s3_deleted?: boolean;
  message: string;
}

export const deleteInstallment = async (request: DeleteInstallmentRequest): Promise<DeleteResponse> => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/receivables`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY || '',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Erro ao deletar parcela');
  }

  return response.json();
};

export const deleteDocument = async (request: DeleteDocumentRequest): Promise<DeleteResponse> => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/receivables`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY || '',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Erro ao deletar documento');
  }

  return response.json();
};
